exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._3GHtXdkR77zNp--qHLtzUx{color:#fff;background-color:#f50;border-radius:100%;height:55px;width:55px;position:relative;top:28px;display:block;font-weight:700;font-size:15px;text-align:center;padding-top:15px;cursor:pointer}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/templates/Event/Athletes/style.css"],"names":[],"mappings":"AAAA,yBACI,WAAY,AACZ,sBAA0B,AAC1B,mBAAoB,AACpB,YAAa,AACb,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,cAAe,AACf,gBAAkB,AAClB,eAAgB,AAChB,kBAAmB,AACnB,iBAAkB,AAClB,cAAgB,CACnB","file":"style.css","sourcesContent":[".circleNum {\n    color: #fff;\n    background-color: #ff5500;\n    border-radius: 100%;\n    height: 55px;\n    width: 55px;\n    position: relative;\n    top: 28px;\n    display: block;\n    font-weight: bold;\n    font-size: 15px;\n    text-align: center;\n    padding-top: 15px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"circleNum": "_3GHtXdkR77zNp--qHLtzUx"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/templates/Event/Athletes/style.css
// module id = 1036
// module chunks = 0 1 2 3